import { Link } from 'react-router-dom';

export default function SecuritySection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-accent-50 text-accent-500 flex items-center justify-center">
          <i className="ri-shield-star-line text-3xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
          <strong>Itaobuy Spreadsheet</strong> &egrave; sicuro?
        </h2>
        <p className="text-base text-foreground-600 mb-6 max-w-xl mx-auto leading-relaxed">
          La sicurezza &egrave; una priorit&agrave; assoluta. <strong>Itaobuy Spreadsheet</strong> adotta protocolli avanzati per garantire che i tuoi dati siano sempre protetti e accessibili solo a te. Con crittografia, backup regolari e controlli di accesso, puoi stare tranquillo.
        </p>
        <Link
          to="/articolo/guida-completa-itaobuy-spreadsheet"
          className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
        >
          <i className="ri-article-line"></i>
          Leggi la nostra analisi completa sulla sicurezza
        </Link>
      </div>
    </section>
  );
}